import { takeEvery, call, put } from "redux-saga/effects";
import {
  ADD_TO_BACKLOG_REQUEST,
  addToBacklogSuccess,
  addToBacklogFailure,
  LIST_BACKLOG_REQUEST,
  listBacklogSuccess,
  listBacklogFailure,
  MARK_AS_POSTED_REQUEST,
  markAsPostedSuccess,
  markAsPostedFailure,
} from "../actions/contentBacklogActions";
import {
  addToBacklogApi,
  listBacklogApi,
  markAsPostedApi,
} from "../apis/contentBacklogApi";

function* addToBacklogSaga(action) {
  try {
    const { tenantId, ...payload } = action.payload;
    const result = yield call(addToBacklogApi, tenantId, payload);
    yield put(addToBacklogSuccess({ ...result, topic: payload.topic }));
  } catch (error) {
    yield put(addToBacklogFailure(error.message));
  }
}

function* listBacklogSaga(action) {
  try {
    const { tenantId } = action.payload;
    const result = yield call(listBacklogApi, tenantId);
    yield put(listBacklogSuccess(result?.items || []));
  } catch (error) {
    yield put(listBacklogFailure(error.message));
  }
}

function* markAsPostedSaga(action) {
  try {
    const { tenantId, backlogId } = action.payload;
    const result = yield call(markAsPostedApi, tenantId, backlogId);
    yield put(markAsPostedSuccess({ backlogId, postedAt: result?.postedAt || new Date().toISOString() }));
  } catch (error) {
    yield put(markAsPostedFailure(error.message));
  }
}

export default function* contentBacklogSaga() {
  yield takeEvery(ADD_TO_BACKLOG_REQUEST,  addToBacklogSaga);
  yield takeEvery(LIST_BACKLOG_REQUEST,    listBacklogSaga);
  yield takeEvery(MARK_AS_POSTED_REQUEST,  markAsPostedSaga);
}
